import { Message } from 'Components/Core';
import { ListFieldSection, Table } from 'Components/Layout';
import { hasValue } from 'Lib/Any';
import { FormatTypes } from 'Lib/Format';
import { ascend } from 'ramda';
import Field from '../../../Core/Field';
import TextOutput from '../../../Core/TextOutput';
import './WorksheetStatusPopupContent.scss';
import { IApiStatusModel } from './types';

type WorksheetStatusPopupContentProps = {
  status: IApiStatusModel;
};

const GetTestStatusCaption = (status: IApiStatusModel): string | undefined => {
  if (status.IsOnSignedReport) return 'Reported';
  if (status.IsChecked) return 'Checked';
  if (status.IsComplete) return 'Ready for checking';

  return `${status.WorkProgress ?? 0}% complete`;
};

/**
 * Renders the content of the popup that appears when clicking on the worksheet status icon
 */
const WorksheetStatusPopupContent: React.FC<WorksheetStatusPopupContentProps> = ({ status }) => {
  const workProgressHistoryRecords = (status.WorkProgressHistory ?? [])
    .filter((t) => hasValue(t.PercentComplete) && hasValue(t.StageCompletedDateTime))
    .sort(ascend((t) => t.StageCompletedDateTime!));
  return (
    <section className="WorksheetStatusPopupContent">
      <ListFieldSection wide>
        <Field input={<TextOutput />} value={GetTestStatusCaption(status)} label="Test Status" horizontal />
      </ListFieldSection>
      <ListFieldSection wide heading="Work Progress History">
        {workProgressHistoryRecords.length <= 0 ? (
          <Message>Work progress history is not available for this test.</Message>
        ) : (
          <Table
            colHeaders={['% Complete', 'Date', 'Time', 'By']}
            colWidths={100}
            data={workProgressHistoryRecords.map((r) => [
              <Field input={<TextOutput />} value={r.PercentComplete} />,
              <Field input={<TextOutput />} value={r.StageCompletedDateTime} format={{ type: FormatTypes.Date }} />,
              <Field
                input={<TextOutput />}
                value={r.StageCompletedDateTime}
                format={{ type: FormatTypes.Time, pattern: 'HH:mm' }}
              />,
              <Field input={<TextOutput />} value={r.StageCompletedBy} />,
            ])}
          />
        )}
      </ListFieldSection>
    </section>
  );
};

export { WorksheetStatusPopupContent };
export default WorksheetStatusPopupContent;
